var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { BodySmall } from '../../typography';
import { fontWeight } from '../../constants';
export var Trigger = styled(BodySmall)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  font-weight: ", ";\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])), fontWeight.bold);
var templateObject_1;
//# sourceMappingURL=TextMenu.styles.js.map